const RUNTIME_DEBUG_EVENT = 'app-runtime:debug-updated'

const FALLBACK_STATE = {
  appBootTimestamp: null,
  authHydrated: false,
  authRehydrationInFlight: false,
  authRehydrationFinishedAt: null,
  lastEvent: null,
  lastRequest: null,
  lastRequestError: null,
  lastReload: null,
  lastReloadSuppression: null,
  pendingFormSubmission: null,
}

let fallbackRuntimeState = {...FALLBACK_STATE}

function emitRuntimeDebugEvent(snapshot) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.dispatchEvent(new CustomEvent(RUNTIME_DEBUG_EVENT, {detail: snapshot}))
  } catch {
    // ignore browsers without CustomEvent support
  }
}

export function ensureRuntimeDebugState() {
  if (typeof window === 'undefined') {
    return fallbackRuntimeState
  }

  if (!window.__APP_RUNTIME__) {
    window.__APP_RUNTIME__ = {}
  }

  if (!window.__APP_RUNTIME__.debug) {
    window.__APP_RUNTIME__.debug = {...FALLBACK_STATE}
  }

  return window.__APP_RUNTIME__.debug
}

export function updateRuntimeDebugState(patch = {}) {
  if (typeof window === 'undefined') {
    fallbackRuntimeState = {
      ...fallbackRuntimeState,
      ...patch,
    }
    return fallbackRuntimeState
  }

  const next = {
    ...ensureRuntimeDebugState(),
    ...patch,
  }

  window.__APP_RUNTIME__.debug = next
  emitRuntimeDebugEvent(next)
  return next
}

export function getRuntimeDebugState() {
  if (typeof window === 'undefined') {
    return fallbackRuntimeState
  }

  return ensureRuntimeDebugState()
}

export function subscribeRuntimeDebugState(listener) {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const handle = event => {
    listener(event?.detail || getRuntimeDebugState())
  }

  window.addEventListener(RUNTIME_DEBUG_EVENT, handle)
  return () => {
    window.removeEventListener(RUNTIME_DEBUG_EVENT, handle)
  }
}

export function createRuntimeDebugEventSummary(type, metadata = {}) {
  return {
    type,
    at: new Date().toISOString(),
    metadata,
  }
}

export function getRuntimeDebugEventName() {
  return RUNTIME_DEBUG_EVENT
}
